// extracted by mini-css-extract-plugin
export default {"CommentsSideHeading":"CommentsSidePanel-module__CommentsSideHeading--fnDjR"};